import registration from './register'
import updatePassword from './update-password'
import { profileFetch, profileUpdate, passwordUpdate, photoUpdate } from './profile'
import { login, logout } from './session'
import twitterLogin from './twitter'
import googleLogin from './google'
import { facebookLogin, facebookLoginError } from './facebook'
import initApp from './init-app'
import { changeAuthState, initAuthFlowParams } from './auth'

export default function* mySaga() {
  yield [
    initApp(),
    registration(),
    updatePassword(),
    profileFetch(),
    profileUpdate(),
    photoUpdate(),
    passwordUpdate(),
    login(),
    logout(),
    twitterLogin(),
    googleLogin(),
    facebookLogin(),
    facebookLoginError(),
    changeAuthState(),
    initAuthFlowParams(),
  ]
}



// WEBPACK FOOTER //
// ./src/sagas/index.js